
import React, { useCallback, useEffect, useRef, useState } from "react";
import "./RegalMenu.scss"
import { fetchAllRestaurantMenuData, getAllData, getAvailableMenuItems, getAvailableMenus, setSelectedOrderType } from "../../../../../../../redux/resturantWidgetSlice";
import { useDispatch, useSelector } from "react-redux";
import arrow from "../../assets/arrow.svg"
import { LOCAL_STORAGE_ITEMS_NAMES } from "../../../../../utilities/helper";
import MenuItem from "../../components/MenuItem/MenuItem";
import order from "../../assets/order-white.svg"
import { useHistory } from "react-router";

const RegalMenu = () => {
    const company = useSelector((state) => state.companyData.company);

    const { menuData: { storage: { mainMenus } }, menuData, defualtSelectedLocation, organizationID, orderCartData } = useSelector((state) => state.resturantData);
    const itemRefs = useRef([]);
    const tabRefs = useRef([]);
    const [data, setData] = useState(null)
    const [itemsData, setItemsData] = useState(data)
    const [isLoading, setIsLoading] = useState(false)
    const [categories, setCategories] = useState([])


    const [selectedItem, setSelectedItem] = useState(sessionStorage.getItem(`scroll`) ? sessionStorage.getItem(`scroll`) : "");
    const dispatch = useDispatch()
    const history = useHistory()
    useEffect(() => {
        window.scrollTo(0, 0);
    }, []);

    const fetchMenuData = useCallback(() => {
        const userId = localStorage.getItem(LOCAL_STORAGE_ITEMS_NAMES.ECOM_RESTAURANT_USER_ID);

        dispatch(fetchAllRestaurantMenuData({
            CloudLocationID: company?.LocationID,
            OrganizationID: company?.OrganisationID,
            UserID: localStorage.getItem('isLogged') && localStorage.getItem('isLogged') === 'true' ? userId : "",
            Type: "MENU"
        }));

    }, [dispatch, defualtSelectedLocation, organizationID]);


    useEffect(() => {
        setIsLoading(true)
        fetchMenuData();

    }, []);
    useEffect(() => {
        getAllData().then((result) => {
            setData(result);

        });
    }, [menuData]);
    useEffect(() => {
        if (data) {
            const menuDataObject = data
            let filteredCategories = getAvailableMenus(
                menuDataObject.data.Menu,
                menuDataObject.data.Categories
            )
            let filteredItems = getAvailableMenuItems(
                menuDataObject.data.Items,
                filteredCategories
            )
            const updatedData = {
                ...menuDataObject.data,
                Categories: filteredCategories,
                Items: filteredItems
            };
            setCategories(filteredCategories);
            setItemsData(updatedData);
            setIsLoading(false)
        }

    }, [isLoading, data]);
    const getCatgoryItems = (menuEntities) => {
        if (!menuEntities || !Array.isArray(menuEntities) || !itemsData?.Items) return [];
        const menuItemIDs = menuEntities.flatMap(entity => entity.ID);
        const items = itemsData.Items.filter(item => menuItemIDs.includes(item.MenuItemID));

        return items;
    }
    useEffect(() => {
        if (data && selectedItem === "" && categories) {
            if (selectedItem === "") {
                setSelectedItem(categories[0]?.MenuCategoryID
                );
                window.scrollTo({ top: 0, behavior: "smooth" });
            } else {
                const selectedItemPosition = itemRefs.current[selectedItem].getBoundingClientRect().top + window.scrollY - 270;
                window.scrollTo(0, parseInt(selectedItemPosition, 10));
            }
        }

    }, [data, categories])
    const containerRef = useRef(null);
    const [showLeftArrow, setShowLeftArrow] = useState(false);
    const [showRightArrow, setShowRightArrow] = useState(true);
    const heightTop = window.innerWidth < 600 ? 310 : 190

    useEffect(() => {
        const handleScroll = () => {

            const scrollPosition = window.scrollY + heightTop;
            let activeId = null;

            Object.entries(itemRefs.current).forEach(([id, item]) => {
                if (item) {
                    const { top, bottom } = item.getBoundingClientRect();
                    const itemTop = top + window.scrollY - heightTop;
                    const itemBottom = bottom + window.scrollY - heightTop;

                    if (itemTop <= scrollPosition && itemBottom >= scrollPosition) {
                        activeId = id;
                    }
                }
            });
            if (activeId) {
                setSelectedItem(activeId);
                tabRefs.current[activeId]?.scrollIntoView({
                    behavior: "smooth",
                    block: "nearest",
                    inline: "center",
                });
            }
        };

        window.addEventListener("scroll", handleScroll);

        return () => window.removeEventListener("scroll", handleScroll);
    }, []);
    const handleSelect = (id) => {
        if (!itemRefs.current[id]) return;

        setSelectedItem(id);

        const selectedItemPosition = itemRefs.current[id].getBoundingClientRect().top + window.scrollY - 270;
        window.scrollTo({ top: selectedItemPosition, behavior: "smooth" });

        setTimeout(() => {
            tabRefs.current[id]?.scrollIntoView({
                behavior: "smooth",
                block: "nearest",
                inline: "center",
            });
        }, 200);
    };
    useEffect(() => {
        const checkScroll = () => {
            const el = containerRef.current;
            if (!el) return;

            setShowLeftArrow(el.scrollLeft > 10);
            setShowRightArrow(el.scrollWidth > el.clientWidth + el.scrollLeft + 10);
        };

        const el = containerRef.current;
        if (el) el.addEventListener("scroll", checkScroll);
        window.addEventListener("resize", checkScroll);

        checkScroll();

        return () => {
            if (el) el.removeEventListener("scroll", checkScroll);
            window.removeEventListener("resize", checkScroll);
        };
    }, [categories]);
    return (
        <div className="RegalMenu">
            <div className="RegalMenu-hero">
                <div className="RegalMenu-hero-header">
                    Our Menu
                </div>
                <div className="RegalMenu-hero-subheader">
                    sweet savouries and street food
                </div>
            </div>
            <div className="RegalMenu-container">
                <div className="RegalMenu-container-header">
                    Discover Regal’s Flavours
                </div>
                <div className="RegalMenu-container-line" />
                {!isLoading ? <>
                    {categories?.length > 0 &&
                        <div className="RegalMenu-container-menu">
                            {showLeftArrow &&
                                <div
                                    className="arrow-emnu-left"
                                    onClick={() =>
                                        (containerRef.current.scrollLeft -= 150)
                                    }
                                >
                                    <img alt="" src={arrow} />
                                </div>}

                            <div className="RegalMenu-container-menu-inner" ref={containerRef}>
                                {categories.map((category) => {
                                    return (
                                        <div
                                            className={selectedItem === category?.MenuCategoryID ? "RegalMenu-container-menu-inner-item-selected" : "RegalMenu-container-menu-inner-item"}
                                            ref={(el) => (tabRefs.current[category?.MenuCategoryID] = el)}
                                            onClick={() => {
                                                handleSelect(category?.MenuCategoryID)
                                            }}
                                        >{category?.Title?.en}</div>
                                    )
                                })}</div>
                            {showRightArrow && <div
                                className="arrow-emnu-right"
                                onClick={() =>
                                    (containerRef.current.scrollLeft += 150)
                                }
                            >
                                <img alt="" src={arrow} />

                            </div>}
                        </div>}
                    {categories?.map((category) => {
                        return (
                            <MenuItem
                                layout={"layout2"}
                                items={
                                    getCatgoryItems(category.MenuEntities)
                                }
                                showHeader
                                headerText={category?.Title?.en}
                                hideFav={true}
                                limited={false}
                                itemRefs={itemRefs}
                                category={category} />
                        )
                    })}
                    <div className="RegalMenu-container-btn"
                        onClick={() => {
                            dispatch(setSelectedOrderType("collection"))
                            history.push("/menu")
                        }}>
                        <img alt="" src={order} />
                        Click and Collect
                    </div>
                </> : <div className="RegalMenu-loader" />}



            </div>
        </div>
    )
}
export default RegalMenu